import SDK from "../../config";
import axios from "axios";
import toast from "react-hot-toast";
import postVisitorsData from "../web/visitors";
import SubscriptionService from "../../services/subscriptionService";

const handlePaymentSuccessSubscription = async ({
  setupIntentId,
  paymentMethodId,
  paymentMethodType,
  cardHolderName,
  customerEmail,
  // customerPhone,
  billingZipcode,
  platformUsed,
  customerId,
  navigate,
}) => {
  const selectedPlan = SDK.getSelectedPlan();
  if (!selectedPlan) {
    toast.error("No plan selected.");
    return;
  }

  const BASE_URL = SDK.getBaseUrl(selectedPlan.pageType);

  const type = SDK.PAGE_TYPE;
  const paymentType = selectedPlan.type;
  const tagsString = [paymentType === "Annual" ? "Yearly" : paymentType];
  const queryParams = new URLSearchParams({
    email_address: customerEmail,
    status: "subscribed",
    tags: tagsString,
    first_name: cardHolderName,
    // phone_number: customerPhone,
    AddToCart: "1",
    reserved: "1",
    type,
  });

  const queryString = queryParams.toString();
  await axios.post(`${BASE_URL}/api/post_email_smashsend?${queryString}`);

  try {
    // Track purchase event using Facebook Pixel if available
    if (window.fbq) {
      window.fbq("track", "Purchase", {
        value: selectedPlan.price,
        contents: [
          {
            id: selectedPlan.type, // monthly / early / lifetime
            quantity: 1,
            item_price: selectedPlan.price,
          },
        ],
        currency: SDK.FB_CURRNECY,
      });
    }

    // Purchase Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmokg", {
        value: selectedPlan.price,
        currency: SDK.FB_CURRNECY,
      });
    }

    // Track complete payment event using TikTok Pixel if available
    // if (window.ttq) {
    //   window.ttq.track("CompletePayment");
    // }

    const userCardData = {
      setupIntentId,
      paymentMethodId,
      paymentMethodType,
      cardHolderName,
      customerEmail,
      // customerPhone,
      billingZipcode,
      platformUsed,
      customerId,
      selectedPlan,
    };
    const paymentIntentResponse = await SubscriptionService.createSubscription(
      userCardData
    );
    if (!paymentIntentResponse.success) {
      // toast.error(
      //   paymentIntentResponse.message || 'Failed to save payment details.'
      // );
      return {
        success: false,
        status: paymentIntentResponse.status,
        data: paymentIntentResponse.error,
      };
    }
    return {
      success: true,
      status: paymentIntentResponse.status,
      data: paymentIntentResponse.data,
    };
  } catch (error) {
    toast.error("Please try again.");
  }
};

export default handlePaymentSuccessSubscription;
